<!--人文美育-视频库管理-->
<template>
    <div class="studio_nav_content" >
        <!--五馆合一-->
        <div class="page-mode" v-show="showMode==='page'">
            <div class="m-box-container">
                <div class="leftgb">
                    <div class="left-top">
                        <div class="left-item-1" >
                            <img class="cursor" @click="viewMuseum('ydtz')" alt="恒岳·阅读拓展馆" style="width: 100%" src="../../assets/museum/mu1.png" />
                        </div>
                        <div class="left-item-1" >
                            <img class="cursor" @click="viewMuseum('kjys')" alt="恒岳·科技艺术馆" style="width: 100%" src="../../assets/museum/mu2.png" />
                        </div>
                    </div>
                    <div class="left-bottom" style="margin-top: 20px">
                        <div class="left-item" >
                            <img class="cursor" @click="viewMuseum('fywh')" alt="恒岳·非遗文化馆" style="width: 100%" src="../../assets/museum/mu3.png" />
                        </div>
                        <div class="left-item" >
                            <img class="cursor" @click="viewMuseum('ldsj')" alt="恒岳·劳动实践营" style="width: 100%" src="../../assets/museum/mu4.png" />
                        </div>
                        <div class="left-item" >
                            <img class="cursor" @click="viewMuseum('zryx')" alt="恒岳·研学体验馆" style="width: 100%" src="../../assets/museum/mu5.png" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!--五馆阅读拓展-->
        <div class="museum-mode" v-show="showMode==='museum-ydtz'">
            <read-extension-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆科技艺术-->
        <div class="museum-mode" v-show="showMode==='museum-kjys'">
            <tech-art-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆非遗文化-->
        <div class="museum-mode" v-show="showMode==='museum-fywh'">
            <intangible-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆劳动实践-->
        <div class="museum-mode" v-show="showMode==='museum-ldsj'">
            <labor-practice-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆自然研学-->
        <div class="museum-mode" v-show="showMode==='museum-zryx'">
            <nature-study-museum @child-back-museum="childBackMuseum" />
        </div>
    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import readExtensionMuseum from "@/components/newMuseum/readExtensionMuseum.vue";
import techArtMuseum from "@/components/newMuseum/techArtMuseum.vue";
import intangibleMuseum from "@/components/newMuseum/intangibleMuseum.vue";
import laborPracticeMuseum from "@/components/newMuseum/laborPracticeMuseum.vue";
import natureStudyMuseum from "@/components/newMuseum/natureStudyMuseum.vue";

export default {
    name: "newFiveMuseum",
    components: {readExtensionMuseum,techArtMuseum,intangibleMuseum,natureStudyMuseum,laborPracticeMuseum},
    data() {
        return {
            showMode:'page',
            museumMode:'museum-',
            serviceUrl,

        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted(){},
    methods: {
        /*查看五馆*/
        viewMuseum(item){
            this.showMode = this.museumMode +item;
            this.$emit('change-mode',this.showMode, 30);
        },
        childBackMuseum(val){
            this.showMode = val;
        }
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}
/*五馆样式*/
.m-box-container{
    display: flex;
    align-items: center;
    justify-content: center;
}
.leftgb {
    width: 74vw;
    height: 95%;
    min-width: 120rpx;
    border-radius: 50rpx;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 20rpx;
}
.left-top{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
    /* align-items: center; */
    justify-content: space-around;
}
.left-item{
    width: 30%;
    height: 65%;
}
.left-item-1{

    width: 35%;
    height: 65%;
    margin-top: 60rpx;
}
.left-bottom{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
}




.museum-mode{
    width: 100%;
    height: auto;
}
</style>